<template>
    <div id="app">
        <el-container
            :style="{ height: '100%' }"
            v-if="$route.path.indexOf('Login') < 0"
        >
            <el-header
                :style="{ background: '#616161', height: '58px' }"
                v-if="LAYOUTMODE.indexOf('top') >= 0"
            >
                <div></div>
                <div class="user-info">
                    <el-avatar
                        :size="'medium'"
                        :src="'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png'"
                    ></el-avatar>
                    <el-dropdown class="user-dropdown" @command="handleCommand">
                        <div class="user-name">
                            <span>您好 {{userInfo.username ? userInfo.username : ""}}</span>
                            <i class="mdi mdi-24px mdi-menu-down"></i>
                        </div>
                        <el-dropdown-menu slot="dropdown">
                            <!-- <el-dropdown-item>
                                <i class="mdi mdi-24px mdi-account-cog"></i>
                                <span>个人设置</span>
                            </el-dropdown-item> -->
                            <el-dropdown-item command="logout">
                                <i class="mdi mdi-24px mdi-logout"></i>
                                <span>退出登陆</span>
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
            </el-header>
            <el-container
                class="main-panel"
                :class="{ 'no-footer': LAYOUTMODE.indexOf('footer') < 0 }">
                <el-aside v-if="LAYOUTMODE.indexOf('aside') >= 0"
                    :class="{'collapse': isCollapse}">
                    <div class="logo-slogan">
                        <img class="logo" :class="{'collapse': isCollapse}" src="./assets/images/logo.png">
                        <img class="slogan" src="./assets/images/slogan.png">
                    </div>
                    <el-menu
                        mode="vertical"
                        :default-active="$route.path"
                        @select="handleMenuSelect"
                        :collapse="isCollapse"
                        unique-opened
                        router>
                        <div v-for="(menuItem, index) in $store.getters.getMenuList" :key="index">
                            <el-menu-item :index="menuItem.index" v-if="menuItem.children.length === 0">
                                <i class="iconfont" :class="[menuItem.functionIcon]" :style="{
                                    'margin-right': '18px',
                                    'font-size': '22px'
                                }"></i>
                                {{menuItem.name}}
                                <span slot="title" v-if="isCollapse">{{menuItem.name}}</span>
                            </el-menu-item>
                            <el-submenu v-else :index="menuItem.index">
                                <template slot="title">
                                    <i class="iconfont" :class="[menuItem.functionIcon]" :style="{
                                        'margin-right': '18px',
                                        'font-size': '22px'
                                    }"></i>
                                    {{menuItem.name}}
                                </template>
                                <el-menu-item v-for="(item, idx) in menuItem.children" :key="idx" :index="item.index">
                                    {{item.name}}
                                </el-menu-item>
                            </el-submenu>
                        </div>
                    </el-menu>
                </el-aside>
                <el-main>
                    <div class="header">
                        <div class="left-panel">
                            <el-button class="fold-btn" type="text" @click="isCollapse = !isCollapse">
                                <i :class="['iconfont', 'icon-' + (!isCollapse ? 'fold' : 'unfold')]"></i>
                            </el-button>
                            <div class="store-name" v-if="userInfo.storeName">{{userInfo.storeName}}</div>
                        </div>
                        <div class="user-info">
                            <el-avatar
                                :size="'medium'"
                                :src="'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png'"
                            ></el-avatar>
                            <el-dropdown class="user-dropdown" @command="handleCommand">
                                <div class="user-name">
                                    <span>您好 {{userInfo.username ? userInfo.username : ""}}</span>
                                    <i class="mdi mdi-24px mdi-menu-down"></i>
                                </div>
                                <el-dropdown-menu slot="dropdown">
                                    <!-- <el-dropdown-item>
                                        <i class="mdi mdi-24px mdi-account-cog"></i>
                                        <span>个人设置</span>
                                    </el-dropdown-item> -->
                                    <el-dropdown-item command="logout">
                                        <i class="mdi mdi-24px mdi-logout"></i>
                                        <span>退出登陆</span>
                                    </el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </div>
                    </div>
                    <el-breadcrumb>
                        <el-breadcrumb-item>
                            <i class="mdi mdi-home"></i>
                        </el-breadcrumb-item>
                        <el-breadcrumb-item v-for="(item, index) in $store.getters.getBreadCrumb" :key="index">
                            {{item.name}}
                        </el-breadcrumb-item>
                    </el-breadcrumb>
                    <div class="router-wrapper">
                        <router-view />
                    </div>
                </el-main>
            </el-container>
            <el-footer
                :style="{ background: '#e0e0e0' }"
                v-if="LAYOUTMODE.indexOf('footer') >= 0"
            ></el-footer>
        </el-container>
        <router-view v-else />
        <div class="seven-am-footer">
            <a href="https://beian.miit.gov.cn/" target="_blank" class="">黑ICP备2023004075号-1</a>
        </div>
    </div>
</template>
<script>
import { CommonApi } from './http/common';
export default {
    name: "app",
    data() {
        return {
            LAYOUTMODE: this.$root.layoutMode,
            currentRoute: "",
            breadCrumbList: [{"name":"基础数据","path":"/Basic"},{"name":"线路","path":"/Basic/RailwayLine"}],
            isCollapse: true,
            userInfo: {}
        };
    },
    mounted() {
        const token = localStorage.getItem('authToken');
        this.$store.commit('updateUserInfo', JSON.parse(localStorage.getItem('userInfo')))
        if(!token)
            this.$router.replace('/Login')
        else
            this.getMenuList();

    },
    watch: {
        $route: {
            handler(newVal){
                localStorage.setItem("historyPath", newVal.path);
                this.updateBreadCrumbList();
            }
        },
        '$store.state.userInfo': {
            handler(newVal){
                this.userInfo = {};
                Object.assign(this.userInfo, newVal);
            },
            deep: true
        }
    },
    methods:{
        getMenuList(){
            CommonApi.getMenuList().then(res => {
                this.$store.commit('updateMenuList', res);
                // const userInfo = localStorage.getItem('userInfo');
                // this.$store.commit('updateUserInfo', JSON.parse(userInfo));
                // Object.assign(this.userInfo, JSON.parse(userInfo));
                // this.storeName = this.$store.getters.getUserInfo.storeName;
                this.updateBreadCrumbList();
            })
        },
        // 控制菜单的选择
        handleMenuSelect(key, keyPath) {
            this.breadCrumbList = [];
            keyPath.forEach(item => {
                this.getBreadcrumbList(item, this.$store.getters.getMenuList);
            });
        },
        // 获取面包屑
        getBreadcrumbList(path, navMenu){
            for(let i = 0; i < navMenu.length; i++){
                if(navMenu[i].index === path){
                    const obj = {
                        name: navMenu[i].name,
                        path: navMenu[i].index
                    }
                    this.breadCrumbList.push(obj);
                    localStorage.setItem('breadcrumb', JSON.stringify(this.breadCrumbList));
                    this.$store.commit('updateBreadcrumb', this.breadCrumbList);
                    break;
                }else{
                    this.getBreadcrumbList(path, navMenu[i].children);
                }
            }
        },
        // 更新面包屑方法
        updateBreadCrumbList(){
            // 全局面包屑变量，每次更新面包屑的时候需要清空
            this.breadCrumbList = [];

            // 面包屑缓冲区，用来更新
            var cachePathArray = [];
            const currentPath = this.$route.path;

            if(currentPath.split('/').length > 2){
                cachePathArray.push('/' + currentPath.split('/')[1]);
            }

            cachePathArray.push(currentPath);

            for(let i = 0; i < cachePathArray.length; i++){
                this.getBreadcrumbList(cachePathArray[i], this.$store.getters.getMenuList);
            }
        },
        handleCommand(command){
            switch (command) {
                case "logout":
                    CommonApi.logout().then(res => {
                        if(res.data.status === 200){
                            this.$notify.success({ title: "已退出登录" });
                            localStorage.setItem('authToken', '');
                            localStorage.setItem('userInfo', '');
                            this.$store.commit('updateUserInfo', {});
                            this.$router.replace('/Login')
                        }
                    })
                    break;
            }
        }
    }
};
</script>
<style lang="less">
@import "./less/global_element_ui.less";
@import "./less/global_components.less";
@import "./less/global_common.less";
.el-container.main-panel{
    height: 100%!important;
    margin: 0;
}
.el-menu{
    border-right: 0px;
    .el-menu-item, .el-submenu__title{
        padding: 0 1.4rem!important;
        border-radius: .8rem;
        margin: .4rem .8rem;
        line-height: 4.4rem;
        height: 4.4rem;
        width: auto;
        &:hover{
            background: #e0e0e0;
        }
    }
    .el-menu-item.is-active{
        background: #e0e0e0;
        font-weight: 500;
    }
    .el-menu-item:hover{
        background: #e0e0e0;
    }
    .el-icon-arrow-right{
        display: none;
    }
    .el-tooltip{
        padding: 0 1.4rem!important;
    }
    .el-menu--inline{
        .el-menu-item{
            padding: 0 1.8rem!important;
        }
    }
}

.el-aside{
    transition: all .3s ease-in;
    width: 26.6rem!important;
    &.collapse{
        width: 6.6rem!important;
    }
}

.el-breadcrumb{
    margin: 1.8rem 1.6rem .2rem 1.6rem;
    .el-breadcrumb__inner{
        color: #9d9d9d;
    }
    i{
        margin-top: -0.4rem;
        color: #616161;
        font-size: 2rem;
        float: left;
    }
    .el-breadcrumb__item:last-child .el-breadcrumb__inner{
        font-weight: bold;
        color: #5473E8;
    }
}
.el-button.fold-btn{
    padding: 1.4rem 1.6rem;
    i{
        color: #333333;
        font-size: 2.8rem;
    }
}
div.header{
    box-shadow: 0 0 10px rgba(0, 0, 0, .15);
    justify-content: space-between;
    background: #ffffff;
    // width: -webkit-fill-available;
    // width: -moz-available;
    // width: fill-available;
    margin-right: 1.2rem;
    border-radius: 1rem;
    position: fixed;
    width: stretch;
    height: 5.8rem;
    display: flex;
    top: 1.2rem;
}
.el-main{
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.15);
    margin: 8.2rem 1.2rem 1.2rem 0;
    border-radius: 1rem;
    div.router-wrapper{
        justify-content: space-between;
        height: calc(100% - 4rem);
        flex-direction: column;
        display: flex;
    }
}
.el-aside{
    box-shadow: 0 2px 12px 0 rgba(0,0,0,.15);
    border-radius: 1rem;
    overflow: hidden;
    margin: 1.2rem;
}
div.logo-slogan{
    align-items: center;
    padding: 1.6rem 0;
    display: flex;
    img{
        // transition: all .3s ease;
        margin: 0 1.2rem;
        height: 3.6rem;
    }
    img.slogan{
        margin-left: .4rem;
        height: 3rem;
    }
}
.seven-am-footer{
    justify-content: center;
    pointer-events: none;
    align-items: center;
    position: fixed;
    display: flex;
    bottom: 1rem;
    height: 4rem;
    width: 100%;
    z-index: 0;
    // bottom: 0;
    a{
        text-decoration: none;
        pointer-events: auto;
        color: #9d9d9d;
    }
}
.header{
    .left-panel{
        align-items: center;
        display: flex;
        .store-name{
            font-weight: bolder;
            font-size: 2rem;
        }
    }
}
</style>
